import { AcceptedChanged, IsAccepted } from "event-definitions"
import { Box } from "@mui/material"
import { noChange } from "lib/@hooks/useRefresh"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { generate } from "library/guid/index.mjs"

export function Approved({ id, children, width = 24, fill = false }) {
    const { target, acceptId } = useBoundContext()
    const isAccepted =
        IsAccepted.call({ isAccepted: undefined, id: id ?? acceptId ?? target.id }) ??
        IsAccepted.call({ isAccepted: undefined, id: target.title ?? generate() })
    AcceptedChanged.after.useRefresh(noChange)
    const hasDecision = typeof isAccepted === "boolean"
    const filler = hasDecision ? (
        <Box
            width={width}
            alignSelf="stretch"
            display="flex"
            alignItems="center"
            overflow="visible"
            justifyContent="center"
            flexDirection="column"
        >
            {fill && (
                <Box width={0} height={0}>
                    <Box height={0} overflow="visible">
                        <Box width={2} height={200000} my={-400} ml={-0.3} flex={1} bgcolor="action.hover" />
                    </Box>
                </Box>
            )}
        </Box>
    ) : null

    return (
        <>
            {filler}
            <OpacityWrapper lowOpacity={hasDecision}>{children}</OpacityWrapper>
        </>
    )
}

export function OpacityWrapper({ lowOpacity, value = 0.5, children }) {
    const childOpacity = lowOpacity
        ? {
              "& > *": {
                  opacity: value,
              },
          }
        : undefined
    return (
        <Box
            sx={{
                display: "contents",
                ...childOpacity,
            }}
        >
            {children}
        </Box>
    )
}
